import { InjectionToken } from "@angular/core";

export const BROWSER_EXTENSION_REQUEST_TIMEOUT = new InjectionToken<number>('browser-extension-request-timeout');
export const BROWSER_EXTENSION_STORE_URL = new InjectionToken<string>('browser-extension-store-url');
